"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var close_directive_1 = require("./close.directive");
exports.CloseSidebar = close_directive_1.CloseSidebar;
var sidebar_component_1 = require("./sidebar.component");
exports.Sidebar = sidebar_component_1.Sidebar;
var sidebar_module_1 = require("./sidebar.module");
exports.SidebarModule = sidebar_module_1.SidebarModule;
var sidebar_service_1 = require("./sidebar.service");
exports.SidebarService = sidebar_service_1.SidebarService;
var sidebar_container_component_1 = require("./sidebar-container.component");
exports.SidebarContainer = sidebar_container_component_1.SidebarContainer;



//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/ng-sidebar/lib/index.js
// module id = ../../../../ng-sidebar/lib/index.js
// module chunks = 9